import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { namespace } from '@/modules/partner/namespace';

type GetPaymentInfoByBIKResult =
  | {
      isError: boolean;
      paymentBankName?: never;
      paymentKorAccount?: never;
    }
  | {
      isError?: never;
      paymentBankName: string;
      paymentKorAccount: string;
    };

const getPaymentInfoByBIK = createAsyncThunk(
  `${namespace}/get-payment-info-by-bik`,
  async (bik: string): Promise<GetPaymentInfoByBIKResult> => {
    const paymentInfo = await partnerAPI.getPaymentInfoByBIK(bik);

    if ('errors' in paymentInfo) {
      return { isError: true };
    }

    return {
      paymentBankName: paymentInfo.bank_name || '',
      paymentKorAccount: paymentInfo.kor_account || '',
    };
  },
);

export { getPaymentInfoByBIK };
